import { FieldTypes, ReferenceCreatedByFields, SelectOptionFields } from 'drapcode-constant';
import { processSteps } from '../collectionForm/utils';
import {
  getCollectionFieldTraitOptions,
  getCollectionFields,
  getCollectionOptionsForSelect,
  getExternalAPIOptionsForSelect,
  getFieldOptionsForSelect,
  getInstalledPlugins,
} from '../pluginComponentApi';
import { getBuilderConfigURL } from '../../../../common/utils/builder-config-url-util';
import { durationOptions } from './consts';
import { filterFieldTraitOptions } from '../dataGroup/traitsApi';

const getFieldOptions = (collection) => {
  let options = [];
  if (collection && collection.fields) {
    const innerFields = collection.fields.filter((field) =>
      SelectOptionFields.includes(field.type),
    );
    options = innerFields.map((field) => {
      return { value: field.fieldName, name: field.fieldTitle.en };
    });
  }
  return options;
};

export default function (editor, opt = {}) {
  const traitManager = editor.TraitManager;
  const {
    projectId,
    collections,
    bindCollectionOptions,
    snippetCollectionTraitOptions,
    token,
    externalApis,
    version,
  } = opt;
  let externalAPIList = externalApis.filter(
    (externalAPI) =>
      externalAPI.responseDataMapping &&
      externalAPI.responseDataMapping.selectedCollectionName !== '',
  );

  let {
    collection: pageCollection,
    session,
    sessionTenant,
    sessionUserSettings,
    sessionSubTenant,
  } = bindCollectionOptions;
  if (!pageCollection) {
    pageCollection = snippetCollectionTraitOptions.collection;
  }

  let innerFieldOptions = [];
  if (pageCollection) {
    const { collectionId } = pageCollection;
    pageCollection = collections.find((col) => col.collectionName === collectionId);
    innerFieldOptions = getFieldOptions(pageCollection);
  }
  let componentContent = '';
  const style = document.createElement('style');
  style.innerHTML = `
        .checkmark::after {
            left: 4px;
            top: 4px;
        }
        checkbox{
        all:unset;
        }
       
        select option:first-child {
            color: grey;
        }
        select.empty {
            color: grey;
        }
        select option[disabled]:first-child {
            display: none;
        }
        .input[type=data-group-text] {
            display:none;
        }
        .width100{
          width: 100%;
        }
  `;
  document.head.appendChild(style);
  if (collections) {
    traitManager.addType('data-calendar-timeslot-collection', {
      createInput({ trait }) {
        const el = document.createElement('div');
        el.classList.add('custom-field');
        el.innerHTML = `    
      <div class="row settings--progress-bar">
        <div class="container">
          <div class="progress">
            <div class="progress-bar"></div>
          </div>
        </div>
      </div>
      <hr/>
      <div id="URL" class="settings--progress">
      ${
        collections || pageCollection
          ? `
          <div class="gjs-container">
            <div class="gjs-row mx-auto mb-2">
              <div class="badge badge-default cms--progress--step-1">
                <i class="wb webconnect"></i>
                <span class="step--desc">Step 1: Select Get Content From</span>
              </div>
            </div>
            <div class="gjs-row">
            <div class="gjs-label-wrp d-none">
            <div class="gjs-label" title="Get Content">Get Content</div>
          </div>
            <div id="select-getContentFrom-div" class="gjs-field-wrp gjs-field-wrp--select-getContentFrom">
              <div class="gjs-field">
                <select class="select-getContentFrom form-control form-control-sm options-light">
                  <option value="">- Get Content -</option>
                  ${
                    collections
                      ? `
                      <option value="collections">Get Data From Collection</option>
                            `
                      : ''
                  }
                </select>
                </div>
              </div>
            </div>
          </div>
          `
          : ''
      }
    <div class="gjs-container cms-data-container" style="display: none">
      <div class="gjs-row mx-auto pb-0" style="justify-content: space-between;">
        <div class="badge badge-default cms--progress--step-2">
          <i class="wb webconnect"></i>
          <span class="step--desc">Step 2: Select Collection / Field</span>
        </div>
        <div class="cms-create-collection-container mb-1" style="display: none;flex-grow: 1;">
          <div class="gjs-row" style="flex-direction: row-reverse;">
            <a href=${getBuilderConfigURL()}collections/${version}/v/${projectId}/create?token=${token} class="direction-custom-link btn btn-outline-light py-0 px-1">
              <i class="wb webconnect-box-arrow-up-right"></i>&nbsp;Create Collection
            </a>
          </div>
        </div>
      </div>
      <div class="gjs-row">
        <div class="gjs-label-wrp d-none">
          <div class="gjs-label select-cms-data-label" title="Collection">Collection</div>
        </div>
        <div id="select-cms-data-div" class="gjs-field-wrp gjs-field-wrp--select-cms-data">
          <div id="select-field-div" style="display: none" class="gjs-field">
            <select class="selectField form-control form-control-sm options-light">
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="gjs-container cms-external-api-container" style="display: none">
      <div class="gjs-row mx-auto pb-0" style="justify-content: space-between;">
        <div class="badge badge-default cms--progress--step-2">
          <i class="wb webconnect"></i>
          <span class="step--desc">Step 2: Select External API</span>
        </div>
        <div class="create-external-api-container" style="display: none;flex-grow: 1;">
          <div class="gjs-row" style="flex-direction: row-reverse;">
            <a href=${getBuilderConfigURL()}externalapi/${version}/v/${projectId}/create?token=${token} class="direction-custom-link btn btn-outline-light py-0 px-1">
              <i class="wb webconnect-box-arrow-up-right"></i>&nbsp;Create ExternalAPI
            </a>
          </div>
        </div>
      </div>
      <div class="gjs-row">
        <div class="gjs-label-wrp d-none">
          <div class="gjs-label select-external-api-label" title="External API">External API</div>
        </div>
        <div id="select-external-api-div" class="gjs-field-wrp gjs-field-wrp--select-external-api">
          <div id="select-external-api-field-div" style="display: none" class="gjs-field">
            <select class="selectExternalApiField form-control form-control-sm options-light">
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="gjs-container cms-filter-container pb-0" style="display: none">
      <div class="gjs-row mx-auto pb-0">
        <div class="badge badge-default cms--progress--step-3">
          <i class="wb webconnect"></i>
          <span class="step--desc">Step 3: Select Filter (Optional)</span>
        </div>
      </div>
    </div>
     <div class="form-group filter-div" style="display: none">
        <select class="filter-select form-control form-control-sm options-light">
        </select>
     </div>
    </div>
    `;
        const cmsDataContainer = el.querySelector('.cms-data-container');
        const cmsCreateCollectionContainer = el.querySelector('.cms-create-collection-container');
        const selectFieldDiv = el.querySelector('#select-field-div');
        const selectField = el.querySelector('.selectField');
        const selectExternalApiField = el.querySelector('.selectExternalApiField');
        const selectGetContentFrom = el.querySelector('.select-getContentFrom');
        const cmsFilterContainer = el.querySelector('.cms-filter-container');
        const cmsExternalAPIContainer = el.querySelector('.cms-external-api-container');
        const cmsCreateExternalAPIContainer = el.querySelector('.create-external-api-container');

        selectGetContentFrom.addEventListener('change', async (ev) => {
          selectField.innerHTML = '';
          let optionHtml = `<option value="">None</option>`;
          selectFieldDiv.style.display = 'block';

          if (selectGetContentFrom.value === 'externalApiResponse') {
            cmsCreateCollectionContainer.style.display = 'none';
            cmsDataContainer.style.display = 'none';
            cmsCreateExternalAPIContainer.style.display = 'block';
            cmsExternalAPIContainer.style.display = 'block';
          } else {
            cmsCreateCollectionContainer.style.display = 'block';
            cmsDataContainer.style.display = 'block';
            cmsCreateExternalAPIContainer.style.display = 'none';
            cmsExternalAPIContainer.style.display = 'none';
          }

          if (['collections', 'browserSession'].includes(selectGetContentFrom.value)) {
            optionHtml = getCollectionOptionsForSelect(collections);
          } else if (selectGetContentFrom.value === 'externalApiResponse') {
            selectExternalApiField.innerHTML = getExternalAPIOptionsForSelect(externalAPIList);
          } else if (selectGetContentFrom.value === 'innerFields') {
            optionHtml = `<option value="" selected>- Select Field -</option>`;
            optionHtml += `${innerFieldOptions
              .map((opt) => `<option value="${opt.value}">${opt.name}</option>`)
              .join('')}`;
          } else {
            cmsCreateCollectionContainer.style.display = 'none';
            cmsDataContainer.style.display = 'none';
            selectFieldDiv.style.display = 'none';
            cmsFilterContainer.style.display = 'none';
            cmsCreateExternalAPIContainer.style.display = 'none';
            cmsExternalAPIContainer.style.display = 'none';
          }
          selectField.innerHTML = optionHtml;
        });

        return el;
      },
      onEvent({ elInput, component }) {
        const traitName = this.model.get('name');
        const select = elInput.querySelector('.selectField');
        const filterDiv = elInput.querySelector('.filter-div');
        const filterSelect = elInput.querySelector('.filter-select');
        const selectGetContentFrom = elInput.querySelector('.select-getContentFrom');
        const cmsDataLabel = elInput.querySelector('.select-cms-data-label');
        const cmsProgressBarContainer = document.querySelector('.settings--progress-bar');
        const cmsProgressStep = document.querySelector('.settings--progress');
        const cmsFilterContainer = document.querySelector('.cms-filter-container');

        const selectExternalApiFieldDiv = elInput.querySelector('#select-external-api-field-div');
        const selectExternalApiField = elInput.querySelector('.selectExternalApiField');
        if (selectGetContentFrom.value) {
          processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
          if (selectGetContentFrom.value === 'innerFields') {
            cmsDataLabel.innerHTML = 'Collection Field';
            component.set('finderUuid', '');
          } else if (selectGetContentFrom.value === 'externalApiResponse') {
            component.set('fieldName', '');
            component.set('finderUuid', '');
            component.set('collectionName', '');
          } else {
            cmsDataLabel.innerHTML = 'Collection';
          }
        }

        let selectedCollection;
        let collectionName;
        if (selectGetContentFrom.value && select.value) {
          if (selectGetContentFrom.value === 'innerFields') {
            filterDiv.style.display = 'none';
            filterSelect.innerHTML = '';
            const selectedRefField = pageCollection.fields.find(
              (field) => field.fieldName === select.value,
            );
            const { refCollection, fieldName } = selectedRefField;
            collectionName = refCollection ? refCollection.collectionName : '';
            component.set('fieldName', fieldName || '');
            component.set('finderUuid', '');
            component.removeTrait('finderUuid');
            const sessionDataPathTrait = component.getTrait('sessionDataPath');
            if (sessionDataPathTrait) {
              component.removeTrait('sessionDataPath');
            }
            selectedCollection = collections.find((coll) => collectionName === coll.collectionName);
          } else if (selectGetContentFrom.value === 'collections') {
            component.set('fieldName', '');
            collectionName = select.value;
            selectedCollection = collections.find((coll) => collectionName === coll.collectionName);
            const finderOptions = selectedCollection.finders.map((finder) => {
              return { value: finder.uuid, name: finder.name };
            });
            const findAllFinder = selectedCollection.finders.find(
              (finder) => finder.name === 'Find All' || finder.name === 'All Items',
            ).uuid;
            const filterTrait = component.getTrait('finderUuid');
            if (collectionName) {
              component.set('finderUuid', findAllFinder);
            } else {
              component.set('finderUuid', '');
            }

            if (!filterTrait) {
              const traitOpts = {
                type: 'select',
                label: false,
                name: 'finderUuid',
                options: finderOptions,
                changeProp: 1,
              };
              component.addTrait(traitOpts, { at: component.getTraitIndex('collectionName') + 1 });
            } else {
              filterTrait.set('options', finderOptions);
            }
          } else if (selectGetContentFrom.value === 'browserSession') {
            component.set('fieldName', '');
            component.set('finderUuid', '');
            component.set('collectionFrom', 'browserSession');
            collectionName = select.value;
            selectedCollection = collections.find((coll) => collectionName === coll.collectionName);

            const filterTrait = component.getTrait('finderUuid');
            if (filterTrait) {
              component.removeTrait('finderUuid');
            }

            const sessionDataPathTrait = component.getTrait('sessionDataPath');
            if (!sessionDataPathTrait) {
              component.addTrait(
                {
                  type: 'text',
                  label: 'Data Path',
                  name: 'sessionDataPath',
                  placeholder: 'ex: data or, response.data', // Placeholder to show inside the input
                  changeProp: 1,
                },
                { at: component.getTraitIndex('collectionName') + 1 },
              );
            }
          }

          const finderUuid = component.get('finderUuid');
          if (finderUuid) {
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepThree');
            cmsFilterContainer.style.display = 'block';
          } else {
            cmsFilterContainer.style.display = 'none';
          }

          let collectionDataStr = selectedCollection ? JSON.stringify(selectedCollection) : '';
          collectionDataStr = collectionDataStr ? collectionDataStr.replaceAll('"', '**##') : '';
          component.set('selectedCollectionData', selectedCollection);
          component.set('selectedCollectionStr', collectionDataStr.toString());
          component.set('collectionName', collectionName);
        } else if (
          selectGetContentFrom.value &&
          selectGetContentFrom.value === 'externalApiResponse'
        ) {
          component.set('fieldName', '');
          component.set('finderUuid', '');
          component.set('collectionFrom', 'externalAPIResponse');
          const filterTrait = component.getTrait('finderUuid');
          if (filterTrait) {
            component.removeTrait('finderUuid');
          }
          const sessionDataPathTrait = component.getTrait('sessionDataPath');
          if (sessionDataPathTrait) {
            component.removeTrait('sessionDataPath');
          }

          selectExternalApiFieldDiv.style.display = 'block';
          const selectedExternalAPI = selectExternalApiField.value
            ? externalAPIList.find(
                (externalAPI) => externalAPI.uuid === selectExternalApiField.value,
              )
            : '';
          const externalAPIResponseCollection = selectedExternalAPI
            ? selectedExternalAPI.responseDataMapping.selectedCollectionName
            : '';
          collectionName = externalAPIResponseCollection ? externalAPIResponseCollection : '';
          selectedCollection = collections.find((coll) => collectionName === coll.collectionName);

          if (selectedExternalAPI) {
            selectedCollection.responseDataMapping =
              selectedExternalAPI.responseDataMapping.selectedMapping;
            selectedCollection.bodyDataFrom = selectedExternalAPI.bodyDataFrom;
            selectedCollection.sendFormData = selectedExternalAPI.sendFormData
              ? selectedExternalAPI.sendFormData
              : false;
            selectedCollection.externalApiId = selectedExternalAPI.uuid;
            let externalAPIData = {
              externalApiId: selectedExternalAPI.uuid,
              responseDataMapping: selectedExternalAPI.responseDataMapping.selectedMapping,
              bodyDataFrom: selectedExternalAPI.bodyDataFrom,
              sendFormData: selectedExternalAPI.sendFormData
                ? selectedExternalAPI.sendFormData
                : false,
            };
            component.set('externalApiData', externalAPIData);
          } else {
            if (selectedCollection) {
              selectedCollection.externalApiId = '';
            }
          }

          const responseDataMappingFields = [];
          if (
            selectedExternalAPI.responseDataMapping &&
            selectedExternalAPI.responseDataMapping.selectedMapping
          ) {
            component.set(
              'externalAPIResponseDataMapping',
              selectedExternalAPI.responseDataMapping.selectedMapping,
            );
            selectedCollection.fields.forEach((element) => {
              if (hiddenFormField.includes(element.fieldName)) {
                responseDataMappingFields.push(element);
              }
              if (
                selectedExternalAPI.responseDataMapping.selectedMapping[element.fieldName] &&
                !element.fieldName.startsWith('_')
              ) {
                responseDataMappingFields.push(element);
              }
            });
          }

          if (responseDataMappingFields && selectedCollection) {
            selectedCollection.fields = responseDataMappingFields;
            component.set('externalAPIResponseDataMappingFields', responseDataMappingFields);
          }
          cmsFilterContainer.style.display = 'none';
          let collectionDataStr = selectedCollection ? JSON.stringify(selectedCollection) : '';
          collectionDataStr = collectionDataStr ? collectionDataStr.replaceAll('"', '**##') : '';
          component.set('selectedCollectionData', selectedCollection);
          component.set('selectedCollectionStr', collectionDataStr.toString());
          component.set('collectionName', collectionName);
        } else {
          cmsDataLabel.innerHTML = '';
          component.set('collectionName', '');
          component.set('fieldName', '');
          component.set('finderUuid', '');
          component.set('collectionFrom', '');
          component.set('externalAPIResponseDataMapping', '');
          component.set('externalApiData', '');
          component.set('externalAPIResponseDataMappingFields', '');

          const filterTrait = component.getTrait('finderUuid');
          if (filterTrait) {
            component.removeTrait('finderUuid');
          }
          const sessionDataPathTrait = component.getTrait('sessionDataPath');
          if (sessionDataPathTrait) {
            component.removeTrait('sessionDataPath');
          }

          processSteps(cmsProgressStep, false, cmsProgressBarContainer);
          if (!select.value && selectGetContentFrom.value) {
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
            cmsFilterContainer.style.display = 'none';
          }
        }
      },
      async onUpdate({ elInput, component }) {
        const componentAttrs = component.getAttributes();
        const cmsDataContainer = elInput.querySelector('.cms-data-container');
        const cmsCreateCollectionContainer = elInput.querySelector(
          '.cms-create-collection-container',
        );
        const selectFieldDiv = elInput.querySelector('#select-field-div');
        const selectField = elInput.querySelector('.selectField');

        const collectionName = component.get('collectionName');
        const fieldName = component.get('fieldName');
        const finderUuid = component.get('finderUuid');
        let selectedCollection = component.get('selectedCollectionData');
        const collectionFrom = component.get('collectionFrom');
        let selectedExternalApiData = component.get('externalApiData');

        let eventDuration = component.get('data-event-duration');
        if (!eventDuration) {
          eventDuration = componentAttrs['data-event-duration'];
        }
        let eventStartTime = component.get('data-event-starttime');
        if (!eventStartTime) {
          eventStartTime = componentAttrs['data-event-starttime'];
        }
        let eventEndTime = component.get('data-event-endtime');
        if (!eventEndTime) {
          eventEndTime = componentAttrs['data-event-endtime'];
        }
        let dayStartAt = component.get('data-fixed-day-start-at');
        if (!dayStartAt) {
          dayStartAt = componentAttrs['data-fixed-day-start-at'];
        }
        let dayEndAt = component.get('data-fixed-day-end-at');
        if (!dayEndAt) {
          dayEndAt = componentAttrs['data-fixed-day-end-at'];
        }
        const selectGetContentFrom = elInput.querySelector('.select-getContentFrom');
        const cmsDataLabel = elInput.querySelector('.select-cms-data-label');

        const cmsProgressBarContainer = elInput.querySelector('.settings--progress-bar');
        const cmsProgressStep = elInput.querySelector('.settings--progress');
        const cmsFilterContainer = elInput.querySelector('.cms-filter-container');

        const cmsExternalAPIContainer = elInput.querySelector('.cms-external-api-container');
        const cmsCreateExternalAPIContainer = elInput.querySelector(
          '.create-external-api-container',
        );
        const selectExternalApiFieldDiv = elInput.querySelector('#select-external-api-field-div');
        const selectExternalApiField = elInput.querySelector('.selectExternalApiField');

        if (!collectionName) {
          selectedCollection = '';
        }

        if (collectionName) {
          const response = await getCollectionFields(collectionName, collections);
          selectedCollection = response;
        }

        if (selectedCollection) {
          if (selectedExternalApiData) {
            if (
              !selectedCollection['externalApiId'] &&
              selectedExternalApiData.hasOwnProperty('externalApiId')
            ) {
              selectedCollection.externalApiId = selectedExternalApiData.externalApiId;
            }
            if (
              !selectedCollection['responseDataMapping'] &&
              selectedExternalApiData.hasOwnProperty('responseDataMapping')
            ) {
              selectedCollection.responseDataMapping = selectedExternalApiData.responseDataMapping;
            }
            if (
              !selectedCollection['bodyDataFrom'] &&
              selectedExternalApiData.hasOwnProperty('bodyDataFrom')
            ) {
              selectedCollection.bodyDataFrom = selectedExternalApiData.bodyDataFrom;
            }
            if (
              !selectedCollection['sendFormData'] &&
              selectedExternalApiData.hasOwnProperty('sendFormData')
            ) {
              selectedCollection.sendFormData = selectedExternalApiData.sendFormData;
            }
          }
          let collectionDataStr = selectedCollection ? JSON.stringify(selectedCollection) : '';
          collectionDataStr = collectionDataStr ? collectionDataStr.replaceAll('"', '**##') : '';

          // if (selectedCollection) {
          const finderOptions = [{ value: '', name: '- Select Filter -', disabled: true }];
          const fieldDateTraitsOptions = [{ value: '', name: '- Select Field -', disabled: true }];
          const fieldTextTraitsOptions = [{ value: '', name: '- Select Field -', disabled: true }];
          const fieldUrlTraitsOptions = [{ value: '', name: '- Select Field -', disabled: true }];

          const fieldDurationTraitsOptions = [];
          selectedCollection.finders.forEach((finder) => {
            finderOptions.push({ value: finder.uuid, name: finder.name });
          });
          const fieldDateOptions = await filterFieldTraitOptions(selectedCollection, [
            FieldTypes.time_slot.id,
          ]);
          fieldDateTraitsOptions.push(...fieldDateOptions);
          const fieldTextOptions = await filterFieldTraitOptions(selectedCollection, [
            FieldTypes.text.id,
          ]);
          fieldTextTraitsOptions.push(...fieldTextOptions);
          const fieldUrlOptions = await filterFieldTraitOptions(selectedCollection, [
            FieldTypes.url.id,
          ]);
          fieldUrlTraitsOptions.push(...fieldUrlOptions);
          fieldDurationTraitsOptions.push(...durationOptions);

          const eventStartTimeTrait = component.getTrait('data-event-starttime');
          if (!eventStartTimeTrait) {
            component.addTrait({
              name: 'data-event-starttime',
              label: 'Start Timeslot Field',
              title: `starttime`,
              options: fieldDateTraitsOptions,
              type: 'select',
            });
          } else {
            eventStartTimeTrait.set('options', fieldDateTraitsOptions);
          }
          const eventEndTimeTrait = component.getTrait('data-event-endtime');
          if (!eventEndTimeTrait) {
            component.addTrait({
              name: 'data-event-endtime',
              label: 'End Timeslot Field',
              title: `endtime`,
              options: fieldDateTraitsOptions,
              type: 'select',
            });
          } else {
            eventEndTimeTrait.set('options', fieldDateTraitsOptions);
          }
          const eventDurationTrait = component.getTrait('data-event-duration');
          if (!eventDurationTrait) {
            component.addTrait({
              name: 'data-event-duration',
              label: 'Duration (in Mins.)',
              title: `duration`,
              options: fieldDurationTraitsOptions,
              type: 'select',
            });
          } else {
            eventDurationTrait.set('options', fieldDurationTraitsOptions);
          }

          const overlapSlotsTrait = component.getTrait('data-overlap-slots');
          if (!overlapSlotsTrait) {
            component.addTrait({
              type: 'checkbox',
              label: 'Overlap Slots',
              name: 'data-overlap-slots',
            });
          }

          component.set('selectedCollectionData', selectedCollection);
          component.set('selectedCollectionStr', collectionDataStr.toString());
        }

        if (fieldName && collectionName) {
          selectGetContentFrom.value = `innerFields`;
          let optionHtml = `<option value="" >- Select Field -</option>`;
          selectFieldDiv.style.display = 'block';
          cmsDataContainer.style.display = 'block';
          cmsCreateCollectionContainer.style.display = 'block';
          cmsFilterContainer.style.display = 'none';
          optionHtml += `${innerFieldOptions
            .map((opt) => `<option value="${opt.value}">${opt.name}</option>`)
            .join('')}`;
          selectField.innerHTML = optionHtml;
          selectField.value = fieldName;
          selectExternalApiField.value = '';
        } else if (collectionName && finderUuid) {
          selectGetContentFrom.value = `collections`;
          let optionHtml = `<option value="">- Select Collection -</option>`;
          selectFieldDiv.style.display = 'block';
          cmsDataContainer.style.display = 'block';
          cmsCreateCollectionContainer.style.display = 'block';
          cmsFilterContainer.style.display = 'block';
          optionHtml = getCollectionOptionsForSelect(collections);
          selectField.innerHTML = optionHtml;
          selectField.value = collectionName;
          const finderOptions = selectedCollection
            ? selectedCollection.finders.map((finder) => {
                return { value: finder.uuid, name: finder.name };
              })
            : [];
          const filterTrait = component.getTrait('finderUuid');
          if (!filterTrait) {
            component.addTrait(
              {
                type: 'select',
                label: false,
                name: 'finderUuid',
                options: finderOptions,
                changeProp: 1,
              },
              { at: component.getTraitIndex('collectionName') + 1 },
            );
          } else {
            filterTrait.set('options', finderOptions);
          }
          selectExternalApiField.value = '';
        } else if (collectionName && collectionFrom === 'browserSession') {
          selectGetContentFrom.value = `browserSession`;
          let optionHtml = `<option value="">- Select Collection -</option>`;
          selectFieldDiv.style.display = 'block';
          cmsDataContainer.style.display = 'block';
          cmsCreateCollectionContainer.style.display = 'block';
          cmsFilterContainer.style.display = 'block';
          optionHtml = getCollectionOptionsForSelect(collections);
          selectField.innerHTML = optionHtml;
          selectField.value = collectionName;
          const filterTrait = component.getTrait('finderUuid');
          if (filterTrait) {
            component.removeTrait('finderUuid');
          }

          const sessionDataPathTrait = component.getTrait('sessionDataPath');
          if (!sessionDataPathTrait) {
            component.addTrait(
              {
                type: 'text',
                label: 'Data Path',
                name: 'sessionDataPath',
                placeholder: 'ex: data or, response.data', // Placeholder to show inside the input
                changeProp: 1,
              },
              { at: component.getTraitIndex('collectionName') + 1 },
            );
          }
          selectExternalApiField.value = '';
        } else if (collectionName && collectionFrom === 'externalAPIResponse') {
          selectGetContentFrom.value = `externalApiResponse`;
          selectFieldDiv.style.display = 'none';
          cmsDataContainer.style.display = 'none';
          cmsCreateCollectionContainer.style.display = 'none';
          cmsFilterContainer.style.display = 'none';

          selectExternalApiFieldDiv.style.display = 'block';
          cmsExternalAPIContainer.style.display = 'block';
          cmsCreateExternalAPIContainer.style.display = 'block';

          selectField.value = collectionName;

          selectExternalApiField.innerHTML = getExternalAPIOptionsForSelect(externalAPIList);
          selectExternalApiField.value = selectedCollection ? selectedCollection.externalApiId : '';
        }

        if (selectGetContentFrom.value) {
          processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
          cmsDataLabel.innerHTML = selectGetContentFrom.value
            ? selectGetContentFrom.value === 'collections'
              ? 'Collection'
              : 'Collection Field'
            : '';

          if (collectionName || fieldName || selectField.value || selectExternalApiField.value) {
            if (collectionFrom === 'externalAPIResponse') {
              if (selectExternalApiField.value) {
                processSteps(
                  cmsProgressStep,
                  true,
                  cmsProgressBarContainer,
                  'stepTwo',
                  cmsExternalAPIContainer,
                );
              } else {
                processSteps(
                  cmsProgressStep,
                  false,
                  cmsProgressBarContainer,
                  'stepTwo',
                  cmsExternalAPIContainer,
                );
              }
            } else {
              processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepTwo');
            }

            if (collectionName && finderUuid && collectionFrom !== 'externalAPIResponse') {
              processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepThree');
              cmsFilterContainer.style.display = 'block';
            } else {
              processSteps(cmsProgressStep, false, cmsProgressBarContainer, 'stepThree');
              cmsFilterContainer.style.display = 'none';
            }
          } else {
            if (collectionFrom === 'externalAPIResponse') {
              if (selectExternalApiField.value) {
                processSteps(
                  cmsProgressStep,
                  true,
                  cmsProgressBarContainer,
                  'stepTwo',
                  cmsExternalAPIContainer,
                );
              } else {
                processSteps(
                  cmsProgressStep,
                  false,
                  cmsProgressBarContainer,
                  'stepTwo',
                  cmsExternalAPIContainer,
                );
              }
            } else {
              processSteps(cmsProgressStep, false, cmsProgressBarContainer, 'stepTwo');
            }
          }
        } else {
          processSteps(cmsProgressStep, false, cmsProgressBarContainer);
          cmsDataLabel.innerHTML = '';
          selectFieldDiv.style.display = 'none';
          cmsDataContainer.style.display = 'none';
          cmsCreateCollectionContainer.style.display = 'none';
          cmsFilterContainer.style.display = 'none';
          cmsCreateExternalAPIContainer.style.display = 'none';
          cmsExternalAPIContainer.style.display = 'none';
        }
      },
    });

    traitManager.addType('data-timeslot-field', {
      createInput({ trait }) {
        const customLabel = trait.attributes.customLabel;
        const el = document.createElement('div');
        el.classList.add('custom-field');
        el.innerHTML = `
    <div id="URL">
    ${
      pageCollection || session || sessionTenant || sessionUserSettings || sessionSubTenant
        ? `
        <div class="gjs-container">
          <div class="gjs-row">
          <div class="gjs-label-wrp">
          <div class="gjs-label" title="Get Start/End Day From">Get Start/End Day From</div>
        </div>
            <div id="select-getTextFrom-div" class="gjs-field-wrp gjs-field-wrp--select-getTextFrom">
            <div class="gjs-field">
              <select class="select-getTextFrom form-control form-control-sm options-light">
                <option value="" selected>- Get Start/End Day From -</option>
                <option value="staticValue">Give Fixed Value</option>
                ${
                  pageCollection &&
                  `<option value="collection">${customLabel} - ${pageCollection.collectionTitle}</option>`
                }
                ${session && `<option value="sessionUser">${customLabel} Logged In User</option>`}
                ${
                  sessionTenant &&
                  `<option value="sessionTenant">${customLabel} Logged In ${sessionTenant.collectionTitle}</option>`
                }
                ${
                  sessionUserSettings &&
                  `<option value="sessionUserSettings">${customLabel} Logged In ${sessionUserSettings.collectionTitle}</option>`
                }
                ${
                  sessionSubTenant &&
                  `<option value="sessionSubTenant">${customLabel} Logged In ${sessionSubTenant.collectionTitle}</option>`
                }
                <option value="previousActionResponse">${customLabel} Browser Session</option>
                <option value="previousActionFormData">${customLabel} Browser Session Form Data</option>
                <option value="browserStorage">${customLabel} Collection (Browser Storage)</option>
              </select>
              </div>
            </div>
          </div>
        </div>
        `
        : ''
    }
      <div id="get-content-field-container" class="gjs-container">
        <div class="gjs-row">
          <div id="field-label-div" class="gjs-label-wrp">
              <div class="gjs-label" title="Day Start At Field">Day Start At Field</div>
          </div>
          <div id="select-field-div" class="gjs-field-wrp gjs-field-wrp--select-field-div" style="display: none;">
              <div class="gjs-field gjs-field--select-field-div">
                  <select class="selectField form-control form-control-sm options-light"> </select>
              </div>
          </div>
          <div id="select-url-field-div" class="gjs-field-wrp gjs-field-wrp--select-url-field-div" style="display: none;">
              <div class="gjs-field">
                  <select class="selectURLField form-control form-control-sm options-light"> </select>
              </div>
          </div>
          <div id="json-field-div" class="gjs-field-wrp gjs-field-wrp--json-field-div" style="display: none;">
              <div class="gjs-field">
                  <input class="jsonField form-control form-control-sm" placeholder="Ex. name" />
              </div>
          </div>
        </div>
        <div class="gjs-row">
          <div id="field-label-end-div" class="gjs-label-wrp">
              <div class="gjs-label" title="Day End At Field">Day End At Field</div>
          </div>
          <div id="select-field-end-div" class="gjs-field-wrp gjs-field-wrp--select-field-div" style="display: none;">
              <div class="gjs-field gjs-field--select-field-div">
                  <select class="selectFieldEnd form-control form-control-sm options-light"> </select>
              </div>
          </div>
          <div id="select-url-field-end-div" class="gjs-field-wrp gjs-field-wrp--select-url-field-div" style="display: none;">
              <div class="gjs-field">
                  <select class="selectURLFieldEnd form-control form-control-sm options-light"> </select>
              </div>
          </div>
          <div id="json-field-end-div" class="gjs-field-wrp gjs-field-wrp--json-field-div" style="display: none;">
              <div class="gjs-field">
                  <input class="jsonFieldEnd form-control form-control-sm" placeholder="Ex. name" />
              </div>
          </div>
        </div>
      </div>
      <div id="get-browser-key" class="gjs-container" style="display: none;">
        <div class="gjs-row">
          <div id="entityCollection-label-div" class="gjs-label-wrp">
            <div class="gjs-label" title="Collection Name">Collection Name</div>
          </div>
          <div id="browserStorageKeyDiv" class="gjs-field-wrp gjs-field-wrp--json-field-div" style="display: none;">
            <div class="gjs-field">
              <select class="browserStorageKey form-control form-control-sm options-light"> </select>
            </div>
          </div>
        </div>
        <div class="gjs-row">
          <div id="entityField-label-div" class="gjs-label-wrp">
            <div class="gjs-label" title="Day Start At Field">Day Start At Field</div>
          </div>
          <div id="browserStorageFieldDiv" class="gjs-field-wrp gjs-field-wrp--json-field-div" style="display: none;">
            <div class="gjs-field">
              <select class="browserStorageFieldKey form-control form-control-sm options-light"> </select>
            </div>
          </div>
        </div>
        <div class="gjs-row">
          <div id="entityField-label-end-div" class="gjs-label-wrp">
            <div class="gjs-label" title="Day End At Field">Day End At Field</div>
          </div>
          <div id="browserStorageFieldEndDiv" class="gjs-field-wrp gjs-field-wrp--json-field-div" style="display: none;">
            <div class="gjs-field">
              <select class="browserStorageFieldEndKey form-control form-control-sm options-light"> </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    `;
        const selectGetTextFrom = el.querySelector('.select-getTextFrom');
        const getContentFieldContainer = el.querySelector('#get-content-field-container');
        const fieldLabelDiv = el.querySelector('#field-label-div');
        const fieldLabelEndDiv = el.querySelector('#field-label-end-div');
        const selectFieldDiv = el.querySelector('#select-field-div');
        const selectFieldEndDiv = el.querySelector('#select-field-end-div');
        const jsonFieldDiv = el.querySelector('#json-field-div');
        const jsonFieldEndDiv = el.querySelector('#json-field-end-div');
        const selectField = el.querySelector('.selectField');
        const selectFieldEnd = el.querySelector('.selectFieldEnd');
        const jsonField = el.querySelector('.jsonField');
        const jsonFieldEnd = el.querySelector('.jsonFieldEnd');
        const getBrowserKey = el.querySelector('#get-browser-key');
        const browserStorageKeyDiv = el.querySelector('#browserStorageKeyDiv');
        const browserStorageKeyEndDiv = el.querySelector('#browserStorageFieldEndDiv');
        const browserStorageKey = el.querySelector('.browserStorageKey');
        const browserStorageFieldDiv = el.querySelector('#browserStorageFieldDiv');
        const browserStorageFieldKey = el.querySelector('.browserStorageFieldKey');
        const browserStorageFieldEndKey = el.querySelector('.browserStorageFieldEndKey');
        jsonField.addEventListener('change', async (ev) => {});
        if (selectGetTextFrom) {
          selectGetTextFrom.addEventListener('change', async (ev) => {
            selectField.innerHTML = '';
            selectFieldEnd.innerHTML = '';
            let optionHtml = `<option value="" selected>None</option>`;
            let optionEndHtml = `<option value="" selected>None</option>`;
            if (selectGetTextFrom.value) {
              getContentFieldContainer.style.display = 'block';
            } else {
              getContentFieldContainer.style.display = 'none';
            }
            if (selectGetTextFrom.value === 'sessionUser') {
              optionHtml += `${session.options
                .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
                .join('')}`;
              optionEndHtml += `${session.options
                .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
                .join('')}`;
              selectFieldDiv.style.display = 'block';
              selectFieldEndDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              fieldLabelEndDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              jsonFieldEndDiv.style.display = 'none';
              getBrowserKey.style.display = 'none';
              browserStorageFieldDiv.style.display = 'none';
              browserStorageKeyDiv.style.display = 'none';
              browserStorageKeyEndDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'sessionTenant') {
              optionHtml += `${sessionTenant.options
                .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
                .join('')}`;
              optionEndHtml += `${sessionTenant.options
                .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
                .join('')}`;
              selectFieldDiv.style.display = 'block';
              selectFieldEndDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              fieldLabelEndDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              jsonFieldEndDiv.style.display = 'none';
              getBrowserKey.style.display = 'none';
              browserStorageFieldDiv.style.display = 'none';
              browserStorageKeyDiv.style.display = 'none';
              browserStorageKeyEndDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'sessionUserSettings') {
              optionHtml += `${sessionUserSettings.options
                .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
                .join('')}`;
              optionEndHtml += `${sessionUserSettings.options
                .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
                .join('')}`;
              selectFieldDiv.style.display = 'block';
              selectFieldEndDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              fieldLabelEndDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              jsonFieldEndDiv.style.display = 'none';
              getBrowserKey.style.display = 'none';
              browserStorageFieldDiv.style.display = 'none';
              browserStorageKeyDiv.style.display = 'none';
              browserStorageKeyEndDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'sessionSubTenant') {
              optionHtml += `${sessionSubTenant.options
                .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
                .join('')}`;
              optionEndHtml += `${sessionSubTenant.options
                .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
                .join('')}`;
              selectFieldDiv.style.display = 'block';
              selectFieldEndDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              fieldLabelEndDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              jsonFieldEndDiv.style.display = 'none';
              getBrowserKey.style.display = 'none';
              browserStorageFieldDiv.style.display = 'none';
              browserStorageKeyDiv.style.display = 'none';
              browserStorageKeyEndDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'collection') {
              const fields = await getCollectionFieldTraitOptions(pageCollection, collections);
              optionHtml = pageCollection ? getFieldOptionsForSelect(fields) : '';
              optionEndHtml = pageCollection ? getFieldOptionsForSelect(fields) : '';
              selectFieldDiv.style.display = 'block';
              selectFieldEndDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              fieldLabelEndDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              jsonFieldEndDiv.style.display = 'none';
              getBrowserKey.style.display = 'none';
              browserStorageFieldDiv.style.display = 'none';
              browserStorageKeyDiv.style.display = 'none';
              browserStorageKeyEndDiv.style.display = 'none';
            } else if (
              selectGetTextFrom.value === 'previousActionResponse' ||
              selectGetTextFrom.value === 'previousActionFormData'
            ) {
              jsonFieldDiv.style.display = 'block';
              jsonFieldEndDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              fieldLabelEndDiv.style.display = 'block';
              selectFieldDiv.style.display = 'none';
              selectFieldEndDiv.style.display = 'none';
              getBrowserKey.style.display = 'none';
              browserStorageFieldDiv.style.display = 'none';
              browserStorageKeyDiv.style.display = 'none';
              browserStorageKeyEndDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'browserStorage') {
              browserStorageKey.innerHTML = collections
                ? getCollectionOptionsForSelect(collections)
                : '';
              browserStorageFieldKey.innerHTML = `<option value="" selected>None</option>`;
              browserStorageFieldEndKey.innerHTML = `<option value="" selected>None</option>`;
              getBrowserKey.style.display = 'block';
              browserStorageFieldDiv.style.display = 'block';
              browserStorageKeyDiv.style.display = 'block';
              browserStorageKeyEndDiv.style.display = 'block';
              selectFieldDiv.style.display = 'none';
              selectFieldEndDiv.style.display = 'none';
            } else {
              jsonFieldDiv.style.display = 'none';
              jsonFieldEndDiv.style.display = 'none';
              selectFieldDiv.style.display = 'none';
              selectFieldEndDiv.style.display = 'none';
              fieldLabelDiv.style.display = 'none';
              fieldLabelEndDiv.style.display = 'none';
              getContentFieldContainer.style.display = 'none';
              getBrowserKey.style.display = 'none';
              browserStorageFieldDiv.style.display = 'none';
              browserStorageKeyDiv.style.display = 'none';
              browserStorageKeyEndDiv.style.display = 'none';
            }
            jsonField.value = '';
            jsonFieldEnd.value = '';
            selectField.innerHTML = optionHtml;
            selectFieldEnd.innerHTML = optionEndHtml;
          });
        }
        browserStorageKey.addEventListener('change', async (ev) => {
          const selectedCollection = collections.find(
            (col) => col.collectionName === ev.target.value,
          );
          const fields = await getCollectionFieldTraitOptions(selectedCollection, collections);
          browserStorageFieldKey.innerHTML = getFieldOptionsForSelect(fields);
          browserStorageFieldEndKey.innerHTML = getFieldOptionsForSelect(fields);
        });
        return el;
      },
      onEvent({ elInput, component }) {
        const selectFieldDiv = elInput.querySelector('#select-field-div');
        const selectFieldEndDiv = elInput.querySelector('#select-field-end-div');
        const getContentFieldContainer = elInput.querySelector('#get-content-field-container');
        const fieldLabelDiv = elInput.querySelector('#field-label-div');
        const fieldLabelEndDiv = elInput.querySelector('#field-label-end-div');
        const select = elInput.querySelector('.selectField');
        const selectEnd = elInput.querySelector('.selectFieldEnd');
        const jsonField = elInput.querySelector('.jsonField');
        const jsonFieldEnd = elInput.querySelector('.jsonFieldEnd');
        const selectGetTextFrom = document.querySelector('.select-getTextFrom');
        const selectGetTextFromValue = selectGetTextFrom ? selectGetTextFrom.value : '';
        const selectFieldValue = select.value;
        const selectFieldEndValue = selectEnd.value;
        const jsonFieldValue = jsonField.value;
        const jsonFieldEndValue = jsonFieldEnd.value;
        const browserStorageKey = elInput.querySelector('.browserStorageKey');
        const browserStorageFieldKey = elInput.querySelector('.browserStorageFieldKey');
        const browserStorageFieldEndKey = elInput.querySelector('.browserStorageFieldEndKey');
        const browserStorageKeyValue = browserStorageKey.value || '';
        const browserStorageFieldKeyValue = browserStorageFieldKey.value || '';
        const browserStorageFieldEndKeyValue = browserStorageFieldEndKey.value || '';
        let attr = component.getAttributes();
        if (selectGetTextFromValue) {
          component.set('data-timeslot-meta-field-from', selectGetTextFromValue);
          getContentFieldContainer.style.display = 'block';
          if (
            [
              'sessionUser',
              'sessionTenant',
              'sessionUserSettings',
              'sessionSubTenant',
              'collection',
              'previousActionResponse',
              'previousActionFormData',
              'browserStorage',
            ].includes(selectGetTextFromValue)
          ) {
            delete attr['data-fixed-day-start-at'];
            delete attr['data-fixed-day-end-at'];
            component.setAttributes(attr);
            component.set('data-fixed-day-start-at', '');
            component.set('data-fixed-day-end-at', '');
          }

          if (selectFieldValue || selectFieldEndValue) {
            const id = attr.id;
            attr.id = id;
            component.setAttributes(attr);
            delete attr['data-form-element-data-group'];
            if (selectGetTextFromValue && selectGetTextFromValue === 'sessionUser') {
              attr['data-session-user-start'] = selectFieldValue;
              attr['data-session-user-end'] = selectFieldEndValue;
              delete attr['data-meta-field-page-collection'];
              delete attr['data-session-tenant-start'];
              delete attr['data-session-tenant-end'];
              delete attr['data-session-user-settings-start'];
              delete attr['data-session-user-settings-end'];
              delete attr['data-session-sub-tenant-start'];
              delete attr['data-session-sub-tenant-end'];
              delete attr['data-collection-field-start'];
              delete attr['data-collection-field-end'];
              delete attr['data-previous-action-response-start'];
              delete attr['data-previous-action-response-end'];
              delete attr['data-previous-action-formdata-start'];
              delete attr['data-previous-action-formdata-end'];
              delete attr['data-storage-key'];
              delete attr['data-browser-storage-start'];
              delete attr['data-browser-storage-end'];
              delete attr['data-fixed-day-start-at'];
              delete attr['data-fixed-day-end-at'];
            } else if (selectGetTextFromValue && selectGetTextFromValue === 'sessionTenant') {
              attr['data-session-tenant-start'] = selectFieldValue;
              attr['data-session-tenant-end'] = selectFieldEndValue;
              delete attr['data-meta-field-page-collection'];
              delete attr['data-session-user-start'];
              delete attr['data-session-user-end'];
              delete attr['data-session-user-settings-start'];
              delete attr['data-session-user-settings-end'];
              delete attr['data-session-sub-tenant-start'];
              delete attr['data-session-sub-tenant-end'];
              delete attr['data-collection-field-start'];
              delete attr['data-collection-field-end'];
              delete attr['data-previous-action-response-start'];
              delete attr['data-previous-action-response-end'];
              delete attr['data-previous-action-formdata-start'];
              delete attr['data-previous-action-formdata-end'];
              delete attr['data-storage-key'];
              delete attr['data-browser-storage-start'];
              delete attr['data-browser-storage-end'];
              delete attr['data-fixed-day-start-at'];
              delete attr['data-fixed-day-end-at'];
            } else if (selectGetTextFromValue && selectGetTextFromValue === 'sessionUserSettings') {
              attr['data-session-user-settings-start'] = selectFieldValue;
              attr['data-session-user-settings-end'] = selectFieldEndValue;
              delete attr['data-meta-field-page-collection'];
              delete attr['data-session-tenant-start'];
              delete attr['data-session-tenant-end'];
              delete attr['data-session-user-start'];
              delete attr['data-session-user-end'];
              delete attr['data-session-sub-tenant-start'];
              delete attr['data-session-sub-tenant-end'];
              delete attr['data-collection-field-start'];
              delete attr['data-collection-field-end'];
              delete attr['data-previous-action-response-start'];
              delete attr['data-previous-action-response-end'];
              delete attr['data-previous-action-formdata-start'];
              delete attr['data-previous-action-formdata-end'];
              delete attr['data-storage-key'];
              delete attr['data-browser-storage-start'];
              delete attr['data-browser-storage-end'];
              delete attr['data-fixed-day-start-at'];
              delete attr['data-fixed-day-end-at'];
            } else if (selectGetTextFromValue && selectGetTextFromValue === 'sessionSubTenant') {
              attr['data-session-sub-tenant-start'] = selectFieldValue;
              attr['data-session-sub-tenant-end'] = selectFieldEndValue;
              delete attr['data-meta-field-page-collection'];
              delete attr['data-session-tenant-start'];
              delete attr['data-session-tenant-end'];
              delete attr['data-session-user-settings-start'];
              delete attr['data-session-user-settings-end'];
              delete attr['data-session-user-start'];
              delete attr['data-session-user-end'];
              delete attr['data-collection-field-start'];
              delete attr['data-collection-field-end'];
              delete attr['data-previous-action-response-start'];
              delete attr['data-previous-action-response-end'];
              delete attr['data-previous-action-formdata-start'];
              delete attr['data-previous-action-formdata-end'];
              delete attr['data-storage-key'];
              delete attr['data-browser-storage-start'];
              delete attr['data-browser-storage-end'];
              delete attr['data-fixed-day-start-at'];
              delete attr['data-fixed-day-end-at'];
            } else if (selectGetTextFromValue && selectGetTextFromValue === 'collection') {
              component.set(
                'data-meta-field-page-collection',
                pageCollection ? pageCollection.collectionName : '',
              );
              attr['data-meta-field-page-collection'] = pageCollection
                ? pageCollection.collectionName
                : '';
              attr['data-collection-field-start'] = selectFieldValue;
              attr['data-collection-field-end'] = selectFieldEndValue;
              delete attr['data-session-user-start'];
              delete attr['data-session-user-end'];
              delete attr['data-session-tenant-start'];
              delete attr['data-session-tenant-end'];
              delete attr['data-session-user-settings-start'];
              delete attr['data-session-user-settings-end'];
              delete attr['data-session-sub-tenant-start'];
              delete attr['data-session-sub-tenant-end'];
              delete attr['data-previous-action-response-start'];
              delete attr['data-previous-action-response-end'];
              delete attr['data-previous-action-formdata-start'];
              delete attr['data-previous-action-formdata-end'];
              delete attr['data-storage-key'];
              delete attr['data-browser-storage-start'];
              delete attr['data-browser-storage-end'];
              delete attr['data-fixed-day-start-at'];
              delete attr['data-fixed-day-end-at'];
            }
            component.set('content', '');
            component.setAttributes(attr);
          } else if (selectGetTextFromValue === 'previousActionResponse') {
            attr['data-previous-action-response-start'] = jsonFieldValue ? jsonFieldValue : '';
            attr['data-previous-action-response-end'] = jsonFieldEndValue ? jsonFieldEndValue : '';

            delete attr['data-meta-field-page-collection'];
            delete attr['data-collection-field-start'];
            delete attr['data-collection-field-end'];
            delete attr['data-session-user-start'];
            delete attr['data-session-user-end'];
            delete attr['data-session-tenant-start'];
            delete attr['data-session-tenant-end'];
            delete attr['data-session-user-settings-start'];
            delete attr['data-session-user-settings-end'];
            delete attr['data-session-sub-tenant-start'];
            delete attr['data-session-sub-tenant-end'];
            delete attr['data-previous-action-formdata-start'];
            delete attr['data-previous-action-formdata-end'];
            delete attr['data-storage-key'];
            delete attr['data-browser-storage-start'];
            delete attr['data-browser-storage-end'];
            delete attr['data-fixed-day-start-at'];
            delete attr['data-fixed-day-end-at'];
            component.set('content', '');
            component.set('data-meta-field-page-collection', '');
            component.setAttributes(attr);
            selectFieldDiv.style.display = 'none';
            selectFieldEndDiv.style.display = 'none';
          } else if (selectGetTextFromValue === 'previousActionFormData') {
            attr['data-previous-action-formdata-start'] = jsonFieldValue ? jsonFieldValue : '';
            attr['data-previous-action-formdata-end'] = jsonFieldEndValue ? jsonFieldEndValue : '';
            delete attr['data-meta-field-page-collection'];
            delete attr['data-collection-field-start'];
            delete attr['data-collection-field-end'];
            delete attr['data-session-user-start'];
            delete attr['data-session-user-end'];
            delete attr['data-session-tenant-start'];
            delete attr['data-session-tenant-end'];
            delete attr['data-session-user-settings-start'];
            delete attr['data-session-user-settings-end'];
            delete attr['data-session-sub-tenant-start'];
            delete attr['data-session-sub-tenant-end'];
            delete attr['data-previous-action-response-start'];
            delete attr['data-previous-action-response-end'];
            delete attr['data-storage-key'];
            delete attr['data-browser-storage-start'];
            delete attr['data-browser-storage-end'];
            delete attr['data-fixed-day-start-at'];
            delete attr['data-fixed-day-end-at'];
            component.set('content', '');
            component.set('data-meta-field-page-collection', '');
            component.setAttributes(attr);
            selectFieldDiv.style.display = 'none';
            selectFieldEndDiv.style.display = 'none';
          } else if (selectGetTextFromValue && selectGetTextFromValue === 'browserStorage') {
            attr['data-storage-key'] = `entity_${browserStorageKeyValue}`;
            attr['data-browser-storage-start'] = browserStorageFieldKeyValue;
            attr['data-browser-storage-end'] = browserStorageFieldEndKeyValue;
            component.setAttributes(attr);
            getContentFieldContainer.style.display = 'none';
          } else if (selectGetTextFromValue === 'staticValue') {
            let dayStartAt = component.get('data-fixed-day-start-at');
            if (!dayStartAt) {
              dayStartAt = attr['data-fixed-day-start-at'];
            }
            let dayEndAt = component.get('data-fixed-day-end-at');
            if (!dayEndAt) {
              dayEndAt = attr['data-fixed-day-end-at'];
            }
            const dayStartAtTrait = component.getTrait('data-fixed-day-start-at');
            if (!dayStartAtTrait) {
              component.addTrait(
                {
                  type: 'number',
                  label: 'Day Start At (in 24hrs)',
                  name: 'data-fixed-day-start-at',
                  min: 0,
                  step: 1,
                  max: 12,
                  placeholder: 'Default: 10',
                },
                { at: component.getTraitIndex('title') + 2 },
              );
            } else {
              component.set('data-fixed-day-start-at', dayStartAt);
            }
            const dayEndAtTrait = component.getTrait('data-fixed-day-end-at');
            if (!dayEndAtTrait) {
              component.addTrait(
                {
                  type: 'number',
                  label: 'Day End At (in 24hrs)',
                  name: 'data-fixed-day-end-at',
                  min: 13,
                  step: 1,
                  max: 24,
                  placeholder: 'Default: 20',
                },
                { at: component.getTraitIndex('title') + 3 },
              );
            } else {
              component.set('data-fixed-day-end-at', dayEndAt);
            }
            delete attr['data-meta-field-page-collection'];
            delete attr['data-collection-field-start'];
            delete attr['data-collection-field-end'];
            delete attr['data-session-user-start'];
            delete attr['data-session-user-end'];
            delete attr['data-session-tenant-start'];
            delete attr['data-session-tenant-end'];
            delete attr['data-session-user-settings-start'];
            delete attr['data-session-user-settings-end'];
            delete attr['data-session-sub-tenant-start'];
            delete attr['data-session-sub-tenant-end'];
            delete attr['data-previous-action-response-start'];
            delete attr['data-previous-action-response-end'];
            delete attr['data-storage-key'];
            delete attr['data-browser-storage-start'];
            delete attr['data-browser-storage-end'];
            selectFieldDiv.style.display = 'none';
            selectFieldEndDiv.style.display = 'none';
            fieldLabelDiv.style.display = 'none';
            fieldLabelEndDiv.style.display = 'none';
            getContentFieldContainer.style.display = 'none';
            component.setAttributes(attr);
            component.set('data-meta-field-page-collection', '');
          } else {
            component.setAttributes(attr);
            component.set('content', componentContent);
            component.set('data-meta-field-page-collection', '');
          }
        } else {
          delete attr['data-session-user-start'];
          delete attr['data-session-user-end'];
          delete attr['data-session-tenant-start'];
          delete attr['data-session-tenant-end'];
          delete attr['data-session-user-settings-start'];
          delete attr['data-session-user-settings-end'];
          delete attr['data-session-sub-tenant-start'];
          delete attr['data-session-sub-tenant-end'];
          delete attr['data-meta-field-page-collection'];
          delete attr['data-collection-field-start'];
          delete attr['data-collection-field-end'];
          delete attr['data-previous-action-response-start'];
          delete attr['data-previous-action-response-end'];
          delete attr['data-previous-action-formdata-start'];
          delete attr['data-previous-action-formdata-end'];
          delete attr['data-storage-key'];
          delete attr['data-browser-storage-start'];
          delete attr['data-browser-storage-end'];
          delete attr['data-fixed-day-start-at'];
          delete attr['data-fixed-day-end-at'];
          selectFieldDiv.style.display = 'none';
          selectFieldEndDiv.style.display = 'none';
          fieldLabelDiv.style.display = 'none';
          fieldLabelEndDiv.style.display = 'none';
          getContentFieldContainer.style.display = 'none';
          component.setAttributes(attr);
          component.set('content', componentContent);
          component.set('data-timeslot-meta-field-from', '');
          component.set('data-fixed-day-start-at', '');
          component.set('data-fixed-day-end-at', '');
        }
      },
      async onUpdate({ elInput, component }) {
        const selectFieldDiv = elInput.querySelector('#select-field-div');
        const selectFieldEndDiv = elInput.querySelector('#select-field-end-div');
        const getContentFieldContainer = elInput.querySelector('#get-content-field-container');
        const fieldLabelDiv = elInput.querySelector('#field-label-div');
        const fieldLabelEndDiv = elInput.querySelector('#field-label-end-div');
        const selectField = elInput.querySelector('.selectField');
        const selectFieldEnd = elInput.querySelector('.selectFieldEnd');
        const jsonFieldDiv = elInput.querySelector('#json-field-div');
        const jsonFieldEndDiv = elInput.querySelector('#json-field-end-div');
        const jsonField = elInput.querySelector('.jsonField');
        const jsonFieldEnd = elInput.querySelector('.jsonFieldEnd');
        const selectGetTextFromDiv = elInput.querySelector('#select-getTextFrom-div');
        const selectGetTextFrom = elInput.querySelector('.select-getTextFrom');
        const getBrowserKey = elInput.querySelector('#get-browser-key');
        const browserStorageKeyDiv = elInput.querySelector('#browserStorageKeyDiv');
        // const browserStorageKeyEndDiv = elInput.querySelector('#browserStorageKeyEndDiv');
        const browserStorageKey = elInput.querySelector('.browserStorageKey');
        const browserStorageFieldDiv = elInput.querySelector('#browserStorageFieldDiv');
        const browserStorageFieldEndDiv = elInput.querySelector('#browserStorageFieldEndDiv');
        const browserStorageFieldKey = elInput.querySelector('.browserStorageFieldKey');
        const browserStorageFieldEndKey = elInput.querySelector('.browserStorageFieldEndKey');

        const attr = component.getAttributes();
        //Removes empty attribute key
        delete attr[''];
        const sessionFieldValue = attr['data-session-user-start'] || '';
        const sessionFieldEndValue = attr['data-session-user-end'] || '';
        const sessionTenantFieldValue = attr['data-session-tenant-start'] || '';
        const sessionTenantFieldEndValue = attr['data-session-tenant-end'] || '';
        const sessionUserSettingsFieldValue = attr['data-session-user-settings-start'] || '';
        const sessionUserSettingsFieldEndValue = attr['data-session-user-settings-end'] || '';
        const sessionSubTenantFieldValue = attr['data-session-sub-tenant-start'] || '';
        const sessionSubTenantFieldEndValue = attr['data-session-sub-tenant-end'] || '';
        const collectionFieldValue = attr['data-collection-field-start'] || '';
        const collectionFieldEndValue = attr['data-collection-field-end'] || '';
        const previousActionResponseFieldValue = attr['data-previous-action-response-start'] || '';
        const previousActionResponseFieldEndValue = attr['data-previous-action-response-end'] || '';
        const previousActionFormDataValue = attr['data-previous-action-formdata-start'] || '';
        const previousActionFormDataEndValue = attr['data-previous-action-formdata-end'] || '';
        const getValueFrom = component.get('data-timeslot-meta-field-from') || '';
        let browserStorageKeyValue = attr['data-storage-key'] || '';
        browserStorageKeyValue = browserStorageKeyValue.replace('entity_', '');
        const browserStorageFieldKeyValue = attr['data-browser-storage-start'] || '';
        const browserStorageFieldKeyEndValue = attr['data-browser-storage-end'] || '';

        let selectGetTextFromValue =
          sessionFieldValue || sessionFieldEndValue
            ? 'sessionUser'
            : collectionFieldValue
            ? 'collection'
            : previousActionResponseFieldValue || previousActionResponseFieldEndValue
            ? 'previousActionResponse'
            : previousActionFormDataValue || previousActionFormDataEndValue
            ? 'previousActionFormData'
            : sessionTenantFieldValue || sessionTenantFieldEndValue
            ? 'sessionTenant'
            : sessionUserSettingsFieldValue || sessionUserSettingsFieldEndValue
            ? 'sessionUserSettings'
            : sessionSubTenantFieldValue || sessionSubTenantFieldEndValue
            ? 'sessionSubTenant'
            : browserStorageKeyValue ||
              browserStorageFieldKeyValue ||
              browserStorageFieldKeyEndValue
            ? 'browserStorage'
            : '';

        if (getValueFrom === 'staticValue') {
          selectGetTextFromValue = getValueFrom;
        }

        let dayStartAt = component.get('data-fixed-day-start-at');
        if (!dayStartAt) {
          dayStartAt = attr['data-fixed-day-start-at'];
        }
        let dayEndAt = component.get('data-fixed-day-end-at');
        if (!dayEndAt) {
          dayEndAt = attr['data-fixed-day-end-at'];
        }

        if (selectGetTextFromValue) {
          selectGetTextFromDiv.style.display = 'block';
          getContentFieldContainer.style.display = 'block';
          fieldLabelDiv.style.display = 'block';
          fieldLabelEndDiv.style.display = 'block';
          if (selectGetTextFrom) {
            selectGetTextFrom.value = selectGetTextFromValue;
          }
          if (sessionFieldValue) {
            let optionHtml = `<option value="" selected>None</option>`;
            let optionEndHtml = `<option value="" selected>None</option>`;
            selectFieldDiv.style.display = 'block';
            selectFieldEndDiv.style.display = 'block';
            fieldLabelDiv.style.display = 'block';
            fieldLabelEndDiv.style.display = 'block';
            optionHtml += `${session.options
              .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
              .join('')}`;
            optionEndHtml += `${session.options
              .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
              .join('')}`;
            selectField.innerHTML = optionHtml;
            selectFieldEnd.innerHTML = optionEndHtml;
            selectField.value = sessionFieldValue;
            selectFieldEnd.value = sessionFieldEndValue;
            jsonFieldDiv.style.display = 'none';
            jsonFieldEndDiv.style.display = 'none';
          } else if (sessionTenantFieldValue) {
            let optionHtml = `<option value="" selected>None</option>`;
            let optionEndHtml = `<option value="" selected>None</option>`;
            selectFieldDiv.style.display = 'block';
            selectFieldEndDiv.style.display = 'block';
            fieldLabelDiv.style.display = 'block';
            fieldLabelEndDiv.style.display = 'block';
            optionHtml += `${sessionTenant.options
              .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
              .join('')}`;
            optionEndHtml += `${sessionTenant.options
              .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
              .join('')}`;
            selectField.innerHTML = optionHtml;
            selectFieldEnd.innerHTML = optionEndHtml;
            selectField.value = sessionTenantFieldValue;
            selectFieldEnd.value = sessionTenantFieldEndValue;
            jsonFieldDiv.style.display = 'none';
            jsonFieldEndDiv.style.display = 'none';
          } else if (sessionUserSettingsFieldValue) {
            let optionHtml = `<option value="" selected>None</option>`;
            let optionEndHtml = `<option value="" selected>None</option>`;
            selectFieldDiv.style.display = 'block';
            selectFieldEndDiv.style.display = 'block';
            fieldLabelDiv.style.display = 'block';
            fieldLabelEndDiv.style.display = 'block';
            optionHtml += `${sessionUserSettings.options
              .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
              .join('')}`;
            optionEndHtml += `${sessionUserSettings.options
              .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
              .join('')}`;
            selectField.innerHTML = optionHtml;
            selectFieldEnd.innerHTML = optionEndHtml;
            selectField.value = sessionUserSettingsFieldValue;
            selectFieldEnd.value = sessionUserSettingsFieldEndValue;
            jsonFieldDiv.style.display = 'none';
            jsonFieldEndDiv.style.display = 'none';
          } else if (sessionSubTenantFieldValue) {
            let optionHtml = `<option value="" selected>None</option>`;
            let optionEndHtml = `<option value="" selected>None</option>`;
            selectFieldDiv.style.display = 'block';
            selectFieldEndDiv.style.display = 'block';
            fieldLabelDiv.style.display = 'block';
            fieldLabelEndDiv.style.display = 'block';
            optionHtml += `${sessionSubTenant.options
              .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
              .join('')}`;
            optionEndHtml += `${sessionSubTenant.options
              .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
              .join('')}`;
            selectField.innerHTML = optionHtml;
            selectFieldEnd.innerHTML = optionEndHtml;
            selectField.value = sessionSubTenantFieldValue;
            selectFieldEnd.value = sessionSubTenantFieldEndValue;
            jsonFieldDiv.style.display = 'none';
            jsonFieldEndDiv.style.display = 'none';
          } else if (collectionFieldValue) {
            selectFieldDiv.style.display = 'block';
            selectFieldEndDiv.style.display = 'block';
            fieldLabelDiv.style.display = 'block';
            fieldLabelEndDiv.style.display = 'block';
            const fields = await getCollectionFieldTraitOptions(pageCollection, collections);

            selectField.innerHTML =
              pageCollection && fields ? getFieldOptionsForSelect(fields) : '';
            selectFieldEnd.innerHTML =
              pageCollection && fields ? getFieldOptionsForSelect(fields) : '';

            selectField.value = collectionFieldValue;
            selectFieldEnd.value = collectionFieldEndValue;
            jsonFieldDiv.style.display = 'none';
            jsonFieldEndDiv.style.display = 'none';
          } else if (
            browserStorageKeyValue ||
            browserStorageFieldKeyValue ||
            browserStorageFieldKeyEndValue
          ) {
            browserStorageKey.innerHTML = collections
              ? getCollectionOptionsForSelect(collections)
              : '';
            browserStorageKey.value = browserStorageKeyValue;
            const entityCollection = collections.find(
              (col) => col.collectionName === browserStorageKeyValue,
            );
            const fields = await getCollectionFieldTraitOptions(entityCollection, collections);
            browserStorageFieldKey.innerHTML = getFieldOptionsForSelect(fields);
            browserStorageFieldEndKey.innerHTML = getFieldOptionsForSelect(fields);
            browserStorageFieldKey.value = browserStorageFieldKeyValue;
            browserStorageFieldEndKey.value = browserStorageFieldKeyEndValue;
            getBrowserKey.style.display = 'block';
            browserStorageKeyDiv.style.display = 'block';
            // browserStorageKeyEndDiv.style.display = 'block';
            browserStorageFieldDiv.style.display = 'block';
            browserStorageFieldEndDiv.style.display = 'block';
            getContentFieldContainer.style.display = 'none';
          } else if (selectGetTextFromValue === 'staticValue') {
            selectFieldDiv.style.display = 'none';
            selectFieldEndDiv.style.display = 'none';
            jsonFieldDiv.style.display = 'none';
            jsonFieldEndDiv.style.display = 'none';
            fieldLabelDiv.style.display = 'none';
            fieldLabelEndDiv.style.display = 'none';
            getContentFieldContainer.style.display = 'none';
            getBrowserKey.style.display = 'none';
            browserStorageKeyDiv.style.display = 'none';
            // browserStorageKeyEndDiv.style.display = 'none';
            browserStorageFieldDiv.style.display = 'none';
            browserStorageFieldEndDiv.style.display = 'none';
            const dayStartAtTrait = component.getTrait('data-fixed-day-start-at');
            if (!dayStartAtTrait) {
              component.addTrait(
                {
                  type: 'number',
                  label: 'Day Start At (in 24hrs)',
                  name: 'data-fixed-day-start-at',
                  min: 0,
                  step: 1,
                  max: 12,
                  placeholder: 'Default: 10',
                },
                { at: component.getTraitIndex('title') + 2 },
              );
            } else {
              component.set('data-fixed-day-start-at', dayStartAt);
            }
            const dayEndAtTrait = component.getTrait('data-fixed-day-end-at');
            if (!dayEndAtTrait) {
              component.addTrait(
                {
                  type: 'number',
                  label: 'Day End At (in 24hrs)',
                  name: 'data-fixed-day-end-at',
                  min: 13,
                  step: 1,
                  max: 24,
                  placeholder: 'Default: 20',
                },
                { at: component.getTraitIndex('title') + 3 },
              );
            } else {
              component.set('data-fixed-day-end-at', dayEndAt);
            }
          } else {
            selectFieldDiv.style.display = 'none';
            selectFieldEndDiv.style.display = 'none';
            getBrowserKey.style.display = 'none';
            browserStorageKeyDiv.style.display = 'none';
            // browserStorageKeyEndDiv.style.display = 'none';
            browserStorageFieldDiv.style.display = 'none';
            browserStorageFieldEndDiv.style.display = 'none';
            // fieldLabelDiv.style.display = 'block';
            jsonField.value = previousActionResponseFieldValue || previousActionFormDataValue;
            jsonFieldEnd.value =
              previousActionResponseFieldEndValue || previousActionFormDataEndValue;
            jsonFieldDiv.style.display = 'block';
            jsonFieldEndDiv.style.display = 'block';
          }
        } else {
          selectFieldDiv.style.display = 'none';
          selectFieldEndDiv.style.display = 'none';
          jsonFieldDiv.style.display = 'none';
          jsonFieldEndDiv.style.display = 'none';
          fieldLabelDiv.style.display = 'none';
          fieldLabelEndDiv.style.display = 'none';
          getContentFieldContainer.style.display = 'none';
          getBrowserKey.style.display = 'none';
          browserStorageKeyDiv.style.display = 'none';
          // browserStorageKeyEndDiv.style.display = 'none';
          browserStorageFieldDiv.style.display = 'none';
          browserStorageFieldEndDiv.style.display = 'none';
        }
      },
    });
  } else {
    traitManager.addType('data-calendar-timeslot-collection', {
      createInput({ trait }) {
        const el = document.createElement('div');
        el.innerHTML = ``;
        return el;
      },
    });
  }
}
